interface EmojiURLProps {
  url: string;
  alt: string;
  size?: number | string;
}
export const EmojiURL = ({ url, alt, size = 16 }: EmojiURLProps) => {
  return <img src={url} alt={alt} height={size} width={size} />;
};
